import type { CartesianPose } from '@sb/geometry';
import type { CameraIntrinsicsExtended } from '@sb/integrations/types/cameraTypes';
import type { CaptureMetadata } from '@sb/routine-runner/Step/Capture/captureUtils';
import type { LocateResult } from '@sb/routine-runner/vision/LocateTypes';
import { projectGrasp } from '@sb/routine-runner/vision/projectGrasp';
import { stripSegmentForLog } from '@sb/routine-runner/vision/runLocate';

/**
 * The Locate half of a capture record: the results, and enough of the camera to
 * draw them back onto the saved frame.
 */
export function locateCaptureResults(
  locateResults: LocateResult[],
  intrinsics: CameraIntrinsicsExtended,
  cameraPose: CartesianPose | undefined,
): Required<Pick<CaptureMetadata, 'locateResults' | 'camera'>> {
  return {
    // Mask and contour cost tens of KB per match in the pretty-printed JSON,
    // and the frame plus the box already show what was found.
    locateResults: locateResults.map((result) => ({
      ...stripSegmentForLog(result),
      grasp: cameraPose
        ? projectGrasp(result.pose, intrinsics, cameraPose)
        : undefined,
    })),
    camera: { intrinsics, cameraPose },
  };
}
